const cutPx = (str) => {
  if (typeof str === 'number') return str;
  return +str.replace('px', '');
}

const getIthColumnCells = (table, i) => {
  const rows = table.querySelectorAll('tr');
  const cells = [];
  rows.forEach(row => {
    const tds = row.querySelectorAll('td');
    if (tds[i]) { // i番目の<td>が存在する場合
      // @ts-ignore
      cells.push(tds[i]);
    }
  });
  return cells;
};

const columnResizable = {
  updated(el, binding) {
    if (!el) return;
    if (!binding) return;
    let targetNode = el.querySelector('table');
    for (targetNode = el.querySelector('table'); targetNode.hasChildNodes(); targetNode = targetNode.children[0]) {
      if (['TABLE', 'THEAD'].indexOf(targetNode.nodeName) > -1) break;
    }

    const nodeName = targetNode.nodeName;
    if (['TABLE', 'THEAD'].indexOf(nodeName) < 0) return;
    const table = targetNode.nodeName === 'TABLE' ? targetNode : targetNode.parentElement;
    table.style.borderWidth = '0px';

    // 最初に既存のresizeContainerを削除する（存在すれば）
    const elem = table.parentElement.querySelector('.vue-columns-resizable');
    if (elem) {
      table.parentElement.removeChild(elem);
    }

    const thead = table.querySelector('thead');
    const ths = thead.querySelectorAll('th');
    const tds = table.querySelectorAll('td');
    const barHeight = thead.offsetHeight;

    const resizeContainer = document.createElement('div');

    // table.style.tableLayout = 'fixed';

    let moving = false;
    let movingIndex = 0;

    // let lastThWidth = null;

    tds.forEach((td) => {
      if (td.style.position !== 'sticky') {
        td.style.maxWidth = '0';
        td.style.whiteSpace = 'nowrap';
        td.style.overflow = 'hidden';
        td.style.textOverflow = 'ellipsis';
        // lastThWidth = td.offsetWidth;
      }
      td.style.borderLeft = 'solid 1px rgb(229, 231, 235)';
      td.style.borderBottom = 'solid 1px rgb(229, 231, 235)';
    });

    ths.forEach((th, index) => {
      th.style.borderLeft = 'solid 1px grey';
      th.style.whiteSpace = 'nowrap';
      th.style.overflow = 'hidden';
      th.style.textOverflow = 'ellipsis';
      if (binding && binding.value && binding.value.value && binding.value.value.length > 0) {
        th.style.width = `${binding.value.value[index]}px`;
        th.style.minWidth = `${binding.value.value[index]}px`;
      } else {
        th.style.width = th.offsetWidth;
        th.style.minWidth = th.offsetWidth;
      }

      if (index + 1 >= ths.length) return;

      const nextTh = ths[index + 1];
      const bar = document.createElement('div');

      bar.style.position = 'absolute';
      bar.style.left = `${nextTh.offsetLeft + 0}px`;
      bar.style.top = '0';
      bar.style.height = `${barHeight}px`;
      bar.style.width = '4px';
      bar.style.cursor = 'col-resize';
      bar.style.zIndex = '200';
      bar.className = 'columns-resize-bar';
      bar.style.opacity = '0';
      bar.style.backgroundColor = 'rgb(238, 238, 238)';

      bar.addEventListener('mousedown', () => {
        moving = true;
        movingIndex = index;
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
        bar.style.opacity = '1';
        bar.style.height = `${table.offsetHeight}px`;
      });

      resizeContainer.appendChild(bar);

    });

    let stickyLeft = 0;
    for (let i = 0; i < ths.length; i++) {
      if (ths && ths[i] && ths[i].classList && ths[i].classList.contains('sticky')) {

        // @ts-ignore
        const leftClass = Array.from(ths[i].classList).find((className) => className.startsWith('left-'));
        if (leftClass) ths[i].classList.remove(leftClass);

        ths[i].style.position = 'sticky';
        ths[i].style.left = `${stickyLeft}px`;

        // 対象thカラムのtdにも同様にsticky情報を更新する
        const indexTds = getIthColumnCells(table, i);
        indexTds.forEach((indexTd: any) => {
          // @ts-ignore
          const leftClass = Array.from(indexTd.classList).find((className) => className.startsWith('left-'));
          if (leftClass) indexTd.classList.remove(leftClass);

          indexTd.style.position = 'sticky';
          indexTd.style.left = `${stickyLeft}px`;
        });

        stickyLeft += (ths[i].offsetWidth) ? Number(cutPx(ths[i].offsetWidth)) : 0;
      }
    }


    // const lastTh = ths.slice(-1)[0];
    // lastTh.style.width = lastThWidth;

    table.style.position = 'relative';
    resizeContainer.style.position = 'sticky';
    resizeContainer.style.top = '0px';
    resizeContainer.style.zIndex = '210';

    resizeContainer.style.width = `${table.offsetWidth}px`;
    resizeContainer.className = 'vue-columns-resizable';

    table.parentElement.style.position = 'relative';
    table.parentElement.insertBefore(resizeContainer, table);

    const bars = resizeContainer.querySelectorAll('.columns-resize-bar');

    document.addEventListener('mouseup', () => {
      if (!moving) return;

      moving = false;

      document.body.style.cursor = '';
      document.body.style.userSelect = '';

      bars.forEach((bar, index) => {
        const th = ths[index];
        const nextTh = ths[index + 1];
        th.style.width = `${th.offsetWidth}px`;
        // @ts-ignore
        bar.style.left = `${nextTh.offsetLeft + 0}px`;

        // @ts-ignore
        bar.style.opacity = '0';
      });
      binding.value.handler(Array.from(ths).map((th: any) => th.style.width));
    });

    // カラム幅変更中の処理
    const handleResize = (e) => {
      if (moving) {
        const th = ths[movingIndex]; // 幅を変更中のカラムの<th>要素
        const nextTh = ths[movingIndex + 1]; // 幅を変更中のカラムの<th>要素の右隣の<th>要素
        const bar = bars[movingIndex];

        // カラム変更のハンドルバーを移動した分だけ、thとnextThの要素のwidth等を変更する
        if (e.movementX === 0 && th.style.width === '') {
          th.style.width = `${th.offsetWidth + e.movementX}px`;
          th.style.minWidth = `${th.offsetWidth + e.movementX}px`;
          // th.style.maxWidth = '0';

          nextTh.style.width = `${nextTh.offsetWidth - e.movementX}px`;
          nextTh.style.minWidth = `${nextTh.offsetWidth - e.movementX}px`;
          // nextTh.style.maxWidth = '0';
        } else {
          th.style.width = `${cutPx(th.style.width) + e.movementX}px`;
          th.style.minWidth = `${cutPx(th.style.width) + e.movementX}px`;
          // th.style.maxWidth = '0';

          nextTh.style.width = `${cutPx(nextTh.style.width) - e.movementX}px`;
          nextTh.style.minWidth = `${cutPx(nextTh.style.width) - e.movementX}px`;
          // nextTh.style.maxWidth = '0';

          // 移動量に連動してハンドルバーの位置も変更する
          // @ts-ignore
          bar.style.left = `${nextTh.offsetLeft - 0 + e.movementX}px`;

        }


        // ths[movingIndex] = th;
        // ths[movingIndex + 1] = nextTh;

        // thとnextThにsticky関連の情報を更新する
        let stickyLeft = 0;
        for (let i = 0; i < ths.length; i++) {
          if (ths && ths[i] && ths[i].classList && ths[i].classList.contains('sticky')) {

            // @ts-ignore
            const leftClass = Array.from(ths[i].classList).find((className) => className.startsWith('left-'));
            if (leftClass) ths[i].classList.remove(leftClass);

            ths[i].style.position = 'sticky';
            ths[i].style.left = `${stickyLeft}px`;

            // 対象thカラムのtdにも同様にsticky情報を更新する
            const indexTds = getIthColumnCells(table, i);
            indexTds.forEach((indexTd: any) => {
              // @ts-ignore
              const leftClass = Array.from(indexTd.classList).find((className) => className.startsWith('left-'));
              if (leftClass) indexTd.classList.remove(leftClass);

              indexTd.style.position = 'sticky';
              indexTd.style.left = `${stickyLeft}px`;
            });

            stickyLeft += (ths[i].offsetWidth) ? Number(cutPx(ths[i].offsetWidth)) : 0;
          }
        }
      }
    };

    resizeContainer.addEventListener('mousemove', handleResize);
    table.addEventListener('mousemove', handleResize);

    // table.style.tableLayout = null;
  },
};

export default columnResizable;
